export interface Address {
  address: string
  address2: string
  city: string
  country: string
  state: string
  zip: string
}

export function createAddress(init: Partial<Address> = {}): Address {
  return {
    address: '',
    address2: '',
    city: '',
    country: 'USA',
    state: '',
    zip: '',
    ...init
  }
}

export interface AddressWork extends Address {
  email: string
  employerName: string
  occupation: string
  phone: string
}

export function createAddressWork(init: Partial<AddressWork> = {}): AddressWork {
  return {
    address: '',
    address2: '',
    city: '',
    country: 'USA',
    state: '',
    zip: '',
    email: '',
    employerName: '',
    occupation: '',
    phone: '',
    ...init
  }
}
